module.exports = {"1":{"name":"Buttongrass"},"2":{"name":"Grassland"},"3":{"name":"Shrubland"},"4":{"name":"Mallee Heath"},"5":{"name":"Non Combustible"},"6":{"name":"Pine"},"7":{"name":"Woodland"},"8":{"name":"Spinifex"},"9":{"name":"Forest"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/afdrs_fuel_models.json
// module id = 610
// module chunks = 0